/**
 * verify Feild and freeback pass or not 
 * @param {*} form form data 
 * @param {*} refVerifyFields if null, verify all field; ex: ["thingName", "SN", "laborWarranty", "partsWarranty"]
 */
export const verifyForm = (form, refVerifyFields) => {
    let pass = false;
    if (form) {
        const values = form.values;
        if (values && !form.syncErrors) {
            // check all field has values
            pass = true;
            if (refVerifyFields) {
                // only verify these field
                refVerifyFields.forEach(fieldName => {
                    if (!values[fieldName] && values[fieldName] !== 0) {
                        pass = false;
                    }
                });
            } else {
                const verifyAllFields = form.registeredFields;
                // verify all field
                for (const fieldName in verifyAllFields) {
                    if (!values[fieldName] && values[fieldName] !== 0) {
                        pass = false;
                    }
                }
            }
        }
    }
    return pass;
}

const verifyEmail = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid email address';
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? msg : undefined;
}

const verifyDigit = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid digit';
    return value && !/^[0-9]+$/.test(value) ? msg : undefined;
}

const verifyUrl = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid Url';
    return value && !/(ht|f)tp(s?):\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-.?,'/\\+&amp;%$#_]*)?/.test(value) ? msg : undefined;
}

export const verifyNumber = (value, formObj, e, fieldName) => {
    return verifyDigit(value, '* Invalid number');
}

const maxInteger = (max) => (value) => {
    return value && parseInt(value) > max ? `* Must be ${max} or less` : undefined
}

export const verifyAccount = (value, formObj, e, fieldName) => {
    return verifyEmail(value, '* The account will be your email address');
}

const verifyUpperCase = (value, refMsg) => {
    const msg = refMsg ? refMsg : '* Invalid upper case letter.';
    return value && !/^[A-Z0-9._%+-/ ]+$/.test(value) ? msg : undefined;
}

export const verifyUpperLetter = (value, formObj, e, fieldName) => {
    return verifyUpperCase(value, '* Must be uppercase');
}


const minLength = (min) => (value) => {
    return value && value.length < min ? `* Must be ${min} characters or more` : undefined
}

const maxLength = (max) => (value) => {
    return value && value.length > max ? `* Must be ${max} characters or less` : undefined
}

export const max10 = maxInteger(10);
export const minLength6 = minLength(6);
export const minLength8 = minLength(8);
export const maxLength2 = maxLength(2);
export const maxLength20 = maxLength(20);

export const verifyPasswordConsistent = (value, values) => {
    let newPassword = values.inputNewPassword;    
    return newPassword === value ? undefined : '* No consistent with another one';
}

export const verifyWebUrl = (value, formObj, e, fieldName) => {
    return verifyUrl(value, '* The Web Url is not correct.');
}